const LeaveAdjustmentTypes = {
	// TYPES FOR GET EMPLOYEE LEAVE BALANCE
	GET_EMPLOYEE_LEAVE_BALANCE_START: 'get_employee_leave_balance_start',
	GET_EMPLOYEE_LEAVE_BALANCE_SUCCESS: 'get_employee_leave_balance_success',
	GET_EMPLOYEE_LEAVE_BALANCE_FAILURE: 'get_employee_leave_balance_failure',
	GET_EMPLOYEE_LEAVE_BALANCE_KEY: 'GetEmployeeLeaveBalanceFromWeb',

	// TYPES FOR CREATE LEAVE ADJUSTMENT
	CREATE_LEAVE_ADJUSTMENT_START: 'create_leave_adjustment_start',
	CREATE_LEAVE_ADJUSTMENT_SUCCESS: 'create_leave_adjustment_success',
	CREATE_LEAVE_ADJUSTMENT_FAILURE: 'create_leave_adjustment_failure',
	CREATE_LEAVE_ADJUSTMENT_RESPONSE_RESET: 'create_leave_adjustment_response_reset',
	CREATE_LEAVE_ADJUSTMENT_KEY: 'CreateLeaveAdjustmentFromWeb',

	// GET EMPLOYEE APPROVED LEAVES FOR YEAR
	GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_START: 'get_employee_approved_leaves_for_year_start',
	GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_SUCCESS: 'get_employee_approved_leaves_for_year_success',
	GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_FAILURE: 'get_employee_approved_leaves_for_year_failure',
	GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_KEY: 'GetEmployeeApprovedLeavesForYearFromWeb',

	// UPDATE APPLIED LEAVE
	UPDATE_APPLIED_LEAVE_START: 'update_applied_leave_start',
	UPDATE_APPLIED_LEAVE_SUCCESS: 'update_applied_leave_success',
	UPDATE_APPLIED_LEAVE_FAILURE: 'update_applied_leave_failure',
	UPDATE_APPLIED_LEAVE_RESPONSE_RESET: 'update_applied_leave_response_reset',
	UPDATE_APPLIED_LEAVE_KEY: 'UpdateAppliedLeaveFromWeb',

	// GET LEAVE EDIT HISTORY
	GET_LEAVE_EDIT_HISTORY_START: 'get_leave_edit_history_start',
	GET_LEAVE_EDIT_HISTORY_SUCCESS: 'get_leave_edit_history_success',
	GET_LEAVE_EDIT_HISTORY_FAILURE: 'get_leave_edit_history_failure',
	GET_LEAVE_EDIT_HISTORY_KEY: 'GetLeaveEditHistoryFromWeb',

	// GET LEAVE ADJUSTMENT HISTORY (tblLeaveAdjustment)
	GET_LEAVE_ADJUSTMENT_HISTORY_START: 'get_leave_adjustment_history_start',
	GET_LEAVE_ADJUSTMENT_HISTORY_SUCCESS: 'get_leave_adjustment_history_success',
	GET_LEAVE_ADJUSTMENT_HISTORY_FAILURE: 'get_leave_adjustment_history_failure',
	// API currently encrypts/decrypts this using this key
	GET_LEAVE_ADJUSTMENT_HISTORY_KEY: 'GetEmployeeLeaveAdjustmentHistoryFromApp',

	
	LEAVE_ADJUSTMENT_PAGE_RESET: 'leave_adjustment_page_reset',
};

export default LeaveAdjustmentTypes;

